import { agentClient } from "../../lib/agentClient";
import { bearer } from "../../lib/accessToken";
import { parsePendingWork, type PendingWork } from "./pending";

export interface ContinueScope {
  token: string;
  orgId: string;
  projectId: string;
  userId: string;
  threadId: string;
  /** The workflow the conversation belongs to (its code): the read lives under its routes. */
  workflowCode: string;
}

/** What the conversation's saved checkpoint still owes (`GET /workflows/:code/threads/:threadId/continue`). */
export async function readPendingWork(scope: ContinueScope, signal: AbortSignal): Promise<PendingWork> {
  const query = new URLSearchParams({ organization_id: scope.orgId, project_id: scope.projectId, user_id: scope.userId }).toString();
  const response = await agentClient.fetch(
    `/workflows/${encodeURIComponent(scope.workflowCode)}/threads/${encodeURIComponent(scope.threadId)}/continue?${query}`,
    { signal, headers: { Authorization: bearer(scope.token) } },
  );
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return parsePendingWork(await response.json());
}
